module.exports = __webpack_public_path__ + "img/partner15.48a82beb.png";